module.exports = __webpack_public_path__ + "img/phone2.22ec2c0.png";